import { createSlice } from '@reduxjs/toolkit';
import { Config } from 'Utils/Config';
const initialState = {
  token: '',
  number: '',
  profile: '',
  email: '',
  number: Config.DEFAULT_WHATSAPP_NUMBER
};

export const AuthSlice = createSlice({
  name: 'AuthSlice',
  initialState,

  reducers: {
    setLogin: (state, action) => {
      state.token = action.payload;
    },
    setNumber: (state, action) => {
      state.number = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },

    setProfileData: (state, action) => {
      state.profile = action.payload;
    },

    setLogOut: (state, action) => {
      state.number = '';
      state.email = '';
      state.token = '';
      state.profile = '';
    }
  }
});
export const { setLogin, setLogOut, setEmail, setNumber, setProfileData } =
  AuthSlice.actions;
export default AuthSlice.reducer;
